import * as $http from 'axios'

export default {
    all: () => $http.get('v2/dating_reviews'),
    create: payload => $http.post(`v2/dating_reviews`, payload),
}
